import { indexAddress } from '@/event/account/dashboard/address/indexAddress'
import { showAdressForm } from '@/event/account/dashboard/showFormAddress'

export function toggleShowAddressForm() {
  showAdressForm.value = !showAdressForm.value
  if (showAdressForm.value == false) {
    indexAddress.value = null
  }
}
